module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-5@2x.b537f7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-5@2x.png
// module id = 8FXr
// module chunks = 18